module.exports = __webpack_public_path__ + "static/img/Golf View.ed15460.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/Golf View.jpg
// module id = nxW2
// module chunks = 4